import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../node_modules/lit-element/node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`:host a{color:#0b3184;font-family:Codec Warm,sans-serif;font-weight:600;line-height:1.75em;text-decoration:none}:host a:hover{text-decoration:underline}.text-align-right{text-align:right}.fs-1{font-size:1em}.fs-1125{font-size:1.125em}.fs-125{font-size:1.25em}.fs-1375{font-size:1.375em}.fs-15{font-size:1.5em}.mb-0{margin-bottom:0}.mb-05{margin-bottom:.5em}.mb-1{margin-bottom:1em}`;

export { css_248z as default };
